export const SPOTTER_TEXT_CUSTOMIZATION = {
  'Spotter is your AI analyst. It can answer questions you have about your data source and help you find insights quickly.':
    'The AI Assistant helps you analyze your trading data for better insights. Ask questions about trader performance, transaction volumes, counterparties, or reference data to understand your trading activity.',
  'Meet Spotter, your AI analyst': 'Meet your trading analytics AI Assistant',
  'Ask a question': 'Ask about your trading data',
  'Preview data': 'View data source',
  'To start analyzing, ask a business question about your data.':
    'For example: "Show me top performing traders by volume" or "What were my most active trading days last month?"',
  Spotter: 'AI Assistant',
} as const;

export const SPOTTER_ICON_SPRITE_URL = window.location.hostname.includes(
  'localhost',
)
  ? ''
  : `${window.location.origin}/spotter-icon.svg`;
